import PageData from '../PageData';

const LEADS_ADS_KEY = 'leadAds';

interface Lead {
  adId: string,
  timestamp: string,
  leadType: string
}

export function surveyOnDuplicatedLeadOn(pageData: PageData, currentLeadType: string) {
  const leadAds = JSON.parse(localStorage.getItem(LEADS_ADS_KEY) || '{}');
  const leadsAdsByBrand = leadAds[pageData.brand] || [];
  const currentLead = { adId: pageData.id, timestamp: new Date().toISOString(), leadType: currentLeadType };
  const leadsForAd = leadsAdsByBrand.filter((lead: Lead) => lead.adId == pageData.id);
  leadAds[pageData.brand] = [...leadsAdsByBrand, currentLead];
  localStorage.setItem(LEADS_ADS_KEY, JSON.stringify(leadAds));
}
